<script>
    import Title from "../text/Title.svelte";
    export let field;
</script>

<Title {field} />
